import type { Action } from './actions'

export type State = {|
    +mainNavigationOpen: boolean
|}

const initialState: State = {
    mainNavigationOpen: false
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'TOGGLE_MAIN_NAVIGATION':
            return {
                ...state,
                mainNavigationOpen: action.open
            }
        default:
            return state
    }
}
